import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { installPdfJsPolyfills } from 'app/core/utils/pdfjs-polyfills';

// Must run before pdf.js (and any other consumer) — see polyfill notes.
installPdfJsPolyfills();

bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
